module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxNSI+PHRpdGxlPlN1YnN0aXR1dGlvbl8zPC90aXRsZT48cmVjdCB3aWR0aD0iNy41IiBoZWlnaHQ9IjcuNSIvPjxyZWN0IHg9IjcuNSIgeT0iNy41IiB3aWR0aD0iNy41IiBoZWlnaHQ9IjcuNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/sub.svg
// module id = 840
// module chunks = 0